var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 116,
    viewBox: "0 0 118 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5199 47C71.1399 47 62.6299 46.66 54.6599 44.44C46.8399 42.27 39.6599 38.06 33.2599 33.19C29.0599 30.02 25.2599 27.49 19.8099 27.87C14.4872 28.1651 9.40036 30.1634 5.29993 33.57C-1.63007 39.63 -0.580065 50.84 2.17994 58.72C6.34994 70.59 18.9999 78.84 29.7699 84.21C42.1999 90.42 55.8499 94 69.5499 96.1C81.5499 97.93 96.9599 99.25 107.36 91.42C116.92 84.22 119.54 67.77 117.2 56.67C116.629 53.3898 114.879 50.431 112.28 48.35C105.57 43.44 95.5599 46.72 88.0199 46.88C85.2199 47 82.3799 47 79.5199 47Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0301 115.56C79.3044 115.56 95.7401 114.535 95.7401 113.27C95.7401 112.005 79.3044 110.98 59.0301 110.98C38.7557 110.98 22.3201 112.005 22.3201 113.27C22.3201 114.535 38.7557 115.56 59.0301 115.56Z",
    fill: "#3B0069",
    fillOpacity: 0.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8401 2.17997C78.3813 2.17997 78.8201 1.74121 78.8201 1.19997C78.8201 0.658733 78.3813 0.219971 77.8401 0.219971C77.2989 0.219971 76.8601 0.658733 76.8601 1.19997C76.8601 1.74121 77.2989 2.17997 77.8401 2.17997Z",
    fill: "#3B0069"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0501 97.29C33.5913 97.29 34.0301 96.8513 34.0301 96.31C34.0301 95.7688 33.5913 95.33 33.0501 95.33C32.5088 95.33 32.0701 95.7688 32.0701 96.31C32.0701 96.8513 32.5088 97.29 33.0501 97.29Z",
    fill: "#3B0069"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3899 102.3V106.6",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.23 104.45H91.54",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4499 11.88C46.8413 11.88 36.6671 16.0943 29.1657 23.5957C21.6642 31.0972 17.45 41.2713 17.45 51.88C17.45 81.24 57.4499 108.73 57.4499 108.73C57.4499 108.73 97.45 81.66 97.45 51.88C97.45 41.2713 93.2357 31.0972 85.7342 23.5957C78.2328 16.0943 68.0586 11.88 57.4499 11.88ZM57.4499 66.88C54.3346 66.88 51.2892 65.9567 48.6983 64.2267C46.1075 62.4968 44.0875 60.0377 42.8935 57.1603C41.6995 54.2829 41.385 51.1161 41.9899 48.0601C42.5948 45.004 44.0918 42.1958 46.2919 39.9901C48.492 37.7845 51.2964 36.2803 54.3509 35.6677C57.4054 35.0551 60.5729 35.3615 63.4534 36.5482C66.3338 37.7349 68.798 39.7487 70.5345 42.3351C72.271 44.9216 73.202 47.9647 73.2099 51.08C73.2073 55.259 71.546 59.2661 68.591 62.2211C65.636 65.1761 61.6289 66.8374 57.4499 66.84V66.88Z",
    fill: "white",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 13.29V17.59",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.97 15.44H17.28",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104.65 24.99V29.29",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.49 27.14H106.8",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7599 39.23L52.1399 49.86",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1399 39.23L62.7599 49.86",
    stroke: "#3B0069",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProject);
export default __webpack_public_path__ + "static/media/NoProject.8409bf751648d41dd24c850c2ae03501.svg";
export { ForwardRef as ReactComponent };